import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isOpen", "onRequestClose", "children", "overlayProps", "contentProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { memo, useLayoutEffect } from 'react';
import { Wrapper, Overlay, Content } from './styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Modal = /*#__PURE__*/memo(function (_ref) {
  var isOpen = _ref.isOpen,
      onRequestClose = _ref.onRequestClose,
      children = _ref.children,
      overlayProps = _ref.overlayProps,
      contentProps = _ref.contentProps,
      props = _objectWithoutProperties(_ref, _excluded);

  useLayoutEffect(function () {
    // TODO: solve issue with body width and padding
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = null;
    }
  }, [isOpen]);
  return /*#__PURE__*/_jsxs(Wrapper, _objectSpread(_objectSpread({}, props), {}, {
    "data-open": isOpen,
    children: [/*#__PURE__*/_jsx(Overlay, _objectSpread({
      onClick: onRequestClose
    }, overlayProps)), /*#__PURE__*/_jsx(Content, _objectSpread(_objectSpread({}, contentProps), {}, {
      children: children
    }))]
  }));
});
Modal.defaultProps = {
  children: null,
  overlayProps: {},
  contentProps: {}
};
export default Modal;